import {Form, Button, Upload, message, Card, Select, notification} from 'antd';
import React, {useState, useEffect} from "react";
import jsonfile from './creditnote.json'
import {CisUI} from '../../../../util/CISUI'
import 'react-smart-data-table/dist/react-smart-data-table.css'
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {useHistory} from "react-router-dom";
import StaticSelectedData from "../../../../util/StaticSelectData";
import SelectData from "../../../../util/selectdata";
import IntlMessages from "../../../../util/IntlMessages";
import { UploadOutlined } from '@ant-design/icons';

const {Option} = Select;

const NewCreditNot = (props) => {

    const formRef = React.createRef();

    const [state, setState] = useState({
        po: {},
        items: [],
        isPOApprover: 0,
        hasPayment: 0
    })


    const [setReceivable] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [setcustomer] = useState([]);
    const [bill] = useState(
        {
            total: 0,
            grand_total: 0,
            freight: 0,
            taxp: 0,
            tax_amount: 0,
            discount_p: 0,
            discount_amount: 0
        }
    );

    const [fund, setFund] = useState([]);
    const [lineItems, setLineItems] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);



    const userID = props.match.params.id;

    let isEdit = 0;
    if (userID > 0) {
        isEdit = 1;
    }


    let Title = jsonfile.addtitle;
    let endpoint = jsonfile.urls.add;
    let redirectto = "../" + jsonfile.urls.list;

    if (isEdit === 1) {

        Title = jsonfile.addtitle;
        redirectto = "../../" + jsonfile.urls.list;
    }

    const classifications = SelectData("classifications");

    const onCompanyChangeForCompany = () => {
        const value = CisUI().getUserInfo('com_id') || 0;
        console.log("selected : " + value);
        handleAddRow();
        axios.get("customer/customerinfobycompany?com_id=" + value)
            .then((res) => {
                console.log(res.data);
                if (res.data.status === 1) {
                    setcustomer(res.data.data);
                    setReceivable(res.data.receiveable);
                    setAccounts(res.data.accounts);
                    setFund(res.data.fund);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        onCompanyChangeForCompany();
    }, []);

    /*
    const onCompanyChange = value => {
        console.log("selected : " + value);
        handleAddRow();
        let fl = Companies.filter(item => item.id === value);
        if (fl.length > 0) {
            const company = fl[0];
            const area = company['area'];
            axios.get("customer/customerinfobycompany?com_id=" + value)
                .then((res) => {
                    console.log(res.data);
                    if (res.data.status === 1) {
                        setcustomer(res.data.data);
                        setReceivable(res.data.receiveable);
                        setAccounts(res.data.accounts);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

            // ReceiveAble = SelectData("receiveable?com_id="+value+"&area="+area);
            // Accounts = SelectData("accountslist?com_id="+value+"&area="+area);

            // console.log("selected : "+ JSON.stringify(company));
            //console.log("address : "+ company.address_line_1+", "+company.address_line_2);
            document.getElementById("input_com_address").value = "Test";
            formRef.current.setFieldsValue({
                com_address: company.address_line_1 + ", " + company.address_line_2,
                com_city: company.city,
                com_state: company.state,
                com_zip_code: company.zip_code,
                customer: "",
                customer_address: "",
                customer_city: "",
                customer_state: "",
                customer_zip_code: "",
                shipping_method: "",
                sales_tax_pp: 0
            });
        }
    }

    const oncustomerChange = value => {
        console.log("selected : " + value);
        let fl = customer.filter(item => item.id === value);
        if (fl.length > 0) {
            const company = fl[0];
            console.log("selected : " + JSON.stringify(company));
            var bill = company["address"];

            formRef.current.setFieldsValue({
                customer_address: bill,
                customer_city: company["city"],
                customer_state: company["state_name"],
                customer_zip_code: company["zip_code"]
            });

        }
    }
     */

    const ItemCellChange = idx => e => {
        const {name, value} = e.target;
        const rows = [...lineItems];
        console.log("selectedITems:" + JSON.stringify(rows[idx]));

        if (name === "amount") {
            rows[idx] = {
                account_id: rows[idx].account_id,
                fund_program_id: rows[idx].fund_program_id,
                func_expense_id: rows[idx].func_expense_id,
                restriction_type: rows[idx].restriction_type,
                amount: value,
                note: rows[idx].note,
                classification : rows[idx].classification,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
            };
        } else if (name === "note") {
            rows[idx] = {
                account_id: rows[idx].account_id,
                fund_program_id: rows[idx].fund_program_id,
                func_expense_id: rows[idx].func_expense_id,
                restriction_type: rows[idx].restriction_type,
                amount: rows[idx].amount,
                note: value,
                classification : rows[idx].classification,
                files : rows[idx].files,
                file_location : rows[idx].file_location,
            };
        }

        setLineItems(rows);

        let ttl = 0;
        rows.map((item, index) =>(
            ttl += parseFloat(item.amount)
        ))
        setTotalAmount(ttl);

    };

    const ItemCellChangeAccount = idx => e => {
        console.log("selectedValued:" + e);
        console.log("selectedValuedID:" + idx);

        const rows = [...lineItems];
        rows[idx] = {
            account_id: e,
            fund_program_id: rows[idx].fund_program_id,
            func_expense_id: rows[idx].func_expense_id,
            restriction_type: rows[idx].restriction_type,
            amount: rows[idx].amount,
            note: rows[idx].note,
            classification : rows[idx].classification,
            files : rows[idx].files,
            file_location : rows[idx].file_location,
        };

        setLineItems(rows);

    }

    const ItemCellChangeFundProgram = idx => e => {
        console.log("selectedValued:" + e);
        console.log("selectedValuedID:" + idx);

        const rows = [...lineItems];
        rows[idx] = {
            account_id: rows[idx].account_id,
            fund_program_id: e,
            func_expense_id: rows[idx].func_expense_id,
            restriction_type: rows[idx].restriction_type,
            amount: rows[idx].amount,
            note: rows[idx].note,
            classification : rows[idx].classification,
            files : rows[idx].files,
            file_location : rows[idx].file_location,
        };

        setLineItems(rows);

    }

    const ItemCellChangeRestrictionType = idx => e => {
        console.log("selectedValued:" + e);
        console.log("selectedValuedID:" + idx);

        const rows = [...lineItems];
        rows[idx] = {
            account_id: rows[idx].account_id,
            fund_program_id: rows[idx].fund_program_id,
            func_expense_id: rows[idx].func_expense_id,
            restriction_type: e,
            amount: rows[idx].amount,
            note: rows[idx].note,
            classification : rows[idx].classification,
            files : rows[idx].files,
            file_location : rows[idx].file_location,
        };

        setLineItems(rows);

    }

    const handleAddRow = (index) => () => {
        const itemRow = state.items[index];
        const item = {
            account_id: itemRow.account_id,
            fund_program_id: itemRow.fund_program_id,
            func_expense_id: itemRow.func_expense_id,
            restriction_type: itemRow.restriction_type,
            amount: null,
            note: null,
            classification : null,
            files : [],
            file_location : [],
        };
        setLineItems([...lineItems, item]);
    };

    const handleRemoveRow = idx => e => {
        // console.log(idx);
        // console.log(state.rows);
        let filteredArray = lineItems.filter((item, index) => index !== idx)
        setLineItems(filteredArray);

        let ttl = 0;
        filteredArray.map((item, index) => (
            ttl += parseFloat(item.amount)
        ))
        setTotalAmount(ttl);

    };


    const onFinish = (values) => {

        values["items"] = lineItems;
        values["invoice_id"] = userID;
        values["summary"] = bill;
        console.log(JSON.stringify(values));
        document.getElementById("loader").style.display = "block";
        axios.post(Config.apiserver + endpoint, values)
            .then(res => {
                document.getElementById("loader").style.display = "none";
                console.log(res)
                if (res.data.status === 1) {
                    notification.success({
                        message: 'Success',
                        type: "success",
                        description: res.data.msg
                    });
                    history.push(redirectto);
                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }

            })
            .catch(errors => {
                document.getElementById("loader").style.display = "none";
                console.log(errors.response.data.errors);
            });
    };


    useEffect(() => {
        getPODetails();
    }, []);

    const getPODetails = () => {
        axios.get(Config.apiserver + jsonfile.urls.invoiceview + "/" + userID)
            .then((res) => {
                //console.log(res.data);
                if (res.data.status === 1) {
                    setState({
                        po: res.data.podata,
                        items: res.data.items,
                        hasPayment: res.data.hasPayment
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const [form] = Form.useForm();
    const history = useHistory();

    /*
    const PoStatusUpdate = (id, status) => {
        document.getElementById("loader").style.display = "block";
        axios.get("purchase/postatuschange?po_id=" + id + "&status=" + status)
            .then((res) => {
                document.getElementById("loader").style.display = "none";
                console.log(res.data);
                if (res.data.status === 1) {
                    notification.success({
                        message: 'Success',
                        type: "success",
                        description: res.data.msg
                    });
                    getPODetails();
                } else {
                    document.getElementById("loader").style.display = "none";
                    notification.success({
                        message: 'Failed',
                        type: "danger",
                        description: res.data.msg
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                document.getElementById("loader").style.display = "none";
            });
    }

    var totalAmounts = 0;

    const config = {
        title: 'Alert',
        content: (
            <>
                <ReachableContext.Consumer>{name => `Reachable: ${name}!`}</ReachableContext.Consumer>
                <br/>
                <UnreachableContext.Consumer>{name => `Unreachable: ${name}!`}</UnreachableContext.Consumer>
            </>
        ),
    };

     */


    const ItemCellChangeClassification = idx => e => {
        console.log("selectedValued:" + e);
        console.log("selectedValuedID:" + idx);

        const rows = [...lineItems];
        rows[idx] = {
            account_id: rows[idx].account_id,
            fund_program_id: rows[idx].fund_program_id,
            func_expense_id: rows[idx].func_expense_id,
            restriction_type: rows[idx].restriction_type,
            amount: rows[idx].amount,
            note: rows[idx].note,
            classification : e,
            files : rows[idx].files,
            file_location : rows[idx].file_location,
        };

        setLineItems(rows);

    }


    const token = localStorage.getItem('token');
    let formData = new FormData();
    let fileUID = "";
    const uplod = {
        name: 'file',
        action: Config.apiserver+"fileupload",
        method : 'post',
        headers: {
            'Authorization': token,
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
            if (!isJpgOrPng) {
                message.error('You can only upload jpg, png,and pdf file only!');
            }
            return isJpgOrPng;
        },
        onChange(info) {
            formData.append('file', info.file);
            fileUID = info.file.uid;
            console.log("index : "+info.file.uid);
            console.log(JSON.stringify(info));
            if(info.file.status === "done") {
                if (info.file.xhr.status === 200) {
                    console.log("ServerResponse : "+info.file.response);
                    const data = info.file.response;
                    if(data.status === 1) {
                        const list = [...lineItems];
                        let files = list[data.line_index].files || [];
                        let file_location = list[data.line_index].file_location || [];
                        files.push(data.data.id);
                        file_location.push(data.data.location);
                        list[data.line_index].files = files;
                        list[data.line_index].file_location = file_location;
                        setLineItems(list);
                        console.log("Files : "+JSON.stringify(list[data.line_index]));
                        message.success(`${info.file.name} file uploaded successfully`);
                    }

                } else {
                    message.error(`${info.file.name} file upload failed.`);
                }
            }
        }
    }


    return (
        <>
            <Card title={Title} extra={
                isEdit === 1
                    ? CisUI().addAction('../../' + jsonfile.urls.list)
                    : CisUI().addAction('../' + jsonfile.urls.list)
            }>
                {CisUI().showLoading}

                <div className="row">
                    <div className="col-md-12">
                        <div style={{width: '100%', background: 'white', border: '1px #ddd solid', padding: '20px'}}>
                            <table style={{width: '100%'}}>
                                <tr>
                                    <td style={{width: '50%', textAlign: 'left', paddingTop: '20px'}}>
                                        <h3>Customer Information : </h3>
                                        <h5>Name : {state.po.customer_name}</h5>
                                        <div>Address : {state.po.customer_address}</div>
                                        <div>City
                                            : {state.po.customer_city}, {state.po.customer_state}, {state.po.customer_zipcode}</div>
                                        <div>Phone : {state.po.customer_phone}</div>
                                        <div>Email : {state.po.customer_email}</div>
                                    </td>
                                    <td style={{width: '50%', textAlign: 'left', paddingTop: '20px'}}>
                                        <div><strong>Invoice# :</strong> {state.po.invoice_number}</div>
                                        <div><strong>Date :</strong> {CisUI().DateFormat(state.po.date)}</div>
                                        <div><strong>Accounts Receivable :</strong> {state.po.receiveable}</div>
                                    </td>
                                </tr>
                            </table>

                            <table id="itemtable" style={{marginTop: '30px'}} className="ptable table table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Account</th>
                                    <th>Amount</th>
                                    <th>Description</th>
                                    <th>Fund Program</th>
                                    <th>Restriction Type</th>
                                </tr>
                                </thead>
                                <tbody>
                                {state.items.map((item, idx) => (
                                    <tr id="addr0" key={idx}>
                                        <td style={{width: '30px'}}>
                                            <button type="button" className="btn btn-primary" onClick={handleAddRow(idx)}><IntlMessages
                                                id="Add"/></button>
                                        </td>
                                        <td style={{width: '150px'}}>{item.account_number}-{item.account_name}</td>
                                        <td style={{
                                            width: '70px',
                                            textAlign: 'right'
                                        }}>{CisUI().getCurrencyFormated1((item.total))}</td>
                                        <td>{item.name}</td>
                                        <td>{item.fund_program_name}</td>
                                        <td>{item.restriction_type}</td>
                                    </tr>
                                ))}
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td style={{textAlign: 'right', fontWeight: 'bold'}} colSpan={2}>Total</td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(state.po.total)}</td>
                                </tr>
                                </tfoot>
                            </table>

                            {CisUI().showLoading}
                            {
                                lineItems.length > 0 ?
                                    <Form
                                        form={form}
                                        {...CisUI().formItemLayout}
                                        name="input"
                                        ref={formRef}
                                        className="ant-advanced-search-form"
                                        onFinish={onFinish}
                                        initialValues={{remember: true}}
                                    >
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h2 style={{textAlign: 'left'}}>{<IntlMessages id="Note Items"/>}</h2>
                                                <table id="itemtable" className="ptable table table-bordered">
                                                    <thead>
                                                    <th>#</th>
                                                    <th>Account</th>
                                                    <th>Amount</th>
                                                    <th>Description</th>
                                                    <th>Fund Program</th>
                                                    <th>Restriction Type</th>
                                                    <th>Classification</th>
                                                    <th>Attachment</th>
                                                    </thead>
                                                    <tbody>
                                                    {lineItems.map((item, idx) => (
                                                        <tr id="addr0" key={idx}>
                                                            <td style={{width: '30px'}}><button type="button"
                                                                onClick={handleRemoveRow(idx)}
                                                                className="btn btn-primary btn-circle"><i
                                                                className="fa fa-trash"></i></button></td>
                                                            <td>
                                                                <Select
                                                                    showSearch
                                                                    placeholder="Select an account"
                                                                    optionFilterProp="children"
                                                                    style={{width: '100%'}}
                                                                    value={item.account_id}
                                                                    onChange={ItemCellChangeAccount(idx)}
                                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                >
                                                                    {
                                                                        accounts.map((items, index) =>
                                                                            <Option key={++index}
                                                                                    value={items.id}>{items.name}</Option>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </td>
                                                            <td style={{width: '100px'}}>
                                                                <input className="form-control text-right"
                                                                       style={{textAlign: 'right'}} placeholder="Amount"
                                                                       name="amount" value={item.amount}
                                                                       onChange={ItemCellChange(idx)}/>
                                                            </td>
                                                            <td style={{width: '300px'}}><input
                                                                className="form-control text-right"
                                                                style={{textAlign: 'left'}}
                                                                name="note" value={item.note}
                                                                onChange={ItemCellChange(idx)}/>
                                                            </td>
                                                            <td>
                                                                <Select
                                                                    showSearch
                                                                    placeholder="Select a fund program"
                                                                    optionFilterProp="children"
                                                                    style={{width: '100%'}}
                                                                    defaultValue={item.fund_program_id}
                                                                    onChange={ItemCellChangeFundProgram(idx)}
                                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                >
                                                                    {
                                                                        fund.map((items, index) =>
                                                                            <Option key={++index}
                                                                                    value={items.id}>{items.name}</Option>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </td>
                                                            <td>
                                                                <Select
                                                                    showSearch
                                                                    placeholder="Select a restriction type"
                                                                    optionFilterProp="children"
                                                                    style={{width: '100%'}}
                                                                    defaultValue={item.restriction_type}
                                                                    onChange={ItemCellChangeRestrictionType(idx)}
                                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                >
                                                                    {
                                                                        StaticSelectedData("restrictiontype").map((items, index) =>
                                                                            <Option key={++index}
                                                                                    value={items.id}>{items.name}</Option>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </td>
                                                            <td>
                                                                <Select
                                                                    showSearch
                                                                    placeholder="Select a class"
                                                                    optionFilterProp="children"
                                                                    style={{width: '100%'}}
                                                                    onChange={ItemCellChangeClassification(idx)}
                                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                >
                                                                    {
                                                                        classifications.map((items, index) =>
                                                                            <Option key={++index} value={items.id}>{items.name}</Option>
                                                                        )
                                                                    }
                                                                </Select>
                                                            </td>
                                                            <td>
                                                                <Upload data= {
                                                                    {
                                                                        file : formData,
                                                                        type : "creditnote",
                                                                        file_id : fileUID,
                                                                        row_id : item.id,
                                                                        line_index : idx
                                                                    }
                                                                } {...uplod}>
                                                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                                                </Upload>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                    <tfoot>
                                                    <tr>
                                                        <th colSpan="2">Total =</th>
                                                        <th style={{
                                                            textAlign: 'right',
                                                            fontSize: '15px'
                                                        }}>{CisUI().getCurrencyFormated1(totalAmount || 0)}</th>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12" style={{textAlign: 'center', marginTop: '30px'}}>
                                                <Button id="submitbutton" type="primary" htmlType="submit">
                                                    <IntlMessages id="Submit"/>
                                                </Button>
                                                <button type="button" className="ant-btn ant-alert-info"
                                                   onClick={() => history.goBack()}><IntlMessages id="Cancel"/></button>
                                            </div>
                                        </div>

                                    </Form>
                                    : <></>
                            }

                        </div>

                    </div>
                </div>

            </Card>

        </>
    );
};

export default NewCreditNot;